import caller from "../../helpers/caller";

export default async function postUpdatePaymentMethod(api, payload) {
  const response = await caller(api.post, `/payment_method/update`, payload);
  return response;
}
